const { isVideo } = require('./utils/videoUtils');
const UPLOADS_PATH = process.env.UPLOADS_PATH || './uploads';

const iamtsobj = require('./perhello')

function setAdsExecutable({ proposal }) {
  const str = iamtsobj.iamts();
  let hasConverionObjective =
    proposal.meta && proposal.meta.objectives && proposal.meta.objectives[0].toUpperCase() == 'CONVERSIONS';
  let hasAppInstallObjective =
    proposal.meta && proposal.meta.objectives && proposal.meta.objectives[0].toUpperCase() == 'APP_INSTALLS';
  let { audienceProfile } = proposal;
  let websiteVisitorAudience =
    proposal.audienceProfile && proposal.audienceProfile.find(ap => ap.name == 'websiteVisitors');
  let hasPixel = Boolean(
    websiteVisitorAudience && websiteVisitorAudience.values.find(value => value.type == 'facebookPixel'),
  );
  let hasFbAppSdk = Boolean(
    websiteVisitorAudience && websiteVisitorAudience.values.find(value => value.type == 'fbApp'),
  );
  let webOrAppType;
  try {
    webOrAppType = proposal.meta.webOrApp.type;
  } catch (err) {
    webOrAppType = 'web';
  }
  let isApp = webOrAppType == 'app';
  let isWeb = webOrAppType == 'web';
  let isForm = webOrAppType == 'form';
  for (let ad of proposal.channelAds) {
    if (!ad.executable) ad.executable = { value: true };
    if (!ad.executable.value) continue;
    if (
      (isWeb || isForm) &&
      (ad.channel == 'facebook' || ad.channel == 'instagram') &&
      hasConverionObjective &&
      !hasPixel
    ) {
      ad.executable = { value: false, reason: { type: 'missingPixelForObjectiveCampaign' } };
      continue;
    }
    if (isApp && (ad.channel == 'facebook' || ad.channel == 'instagram') && hasAppInstallObjective && !hasFbAppSdk) {
      ad.executable = { value: false, reason: { type: 'missingFbAppForObjectiveCampaign' } };
      continue;
    }
  }
}

function buildAdId(ad) {
  let { channel, subChannels, creativeType, audience, groupId, creative, objective } = ad;
  if (!groupId) groupId = 1;
  let remarketing = 0;
  Object.values(audience).forEach(val => {
    if (val.remarketing) {
      remarketing = 1;
      return;
    }
  });
  if (ad.hasOwnProperty('remarketing')) {
    if (ad.remarketing) remarketing = 1;
  }
  let video = 0;
  if (creative && creative.media && isVideo(path.join(UPLOADS_PATH, creative.media))) {
    video = 1;
  }
  let conversion = 0;
  if (objective === 'CONVERSIONS') {
    conversion = 1;
  }
  let url = '';
  if (creative && creative.url) {
    url = creative.url;
  }
  return `${channel}:${subChannels.join(':')}:${creativeType}:${groupId}:${remarketing}:${video}:${conversion}:${url}`;
}

function isSameAdId(ad1, ad2) {
  return buildAdId(ad1) === buildAdId(ad2);
}

module.exports = {
  isSameAdId,
  setAdsExecutable,
};
